{
  "version": 1,
  "asset_id": "fc688624-8be2-4107-8ed6-b7d49dbdb824",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/fc688624-8be2-4107-8ed6-b7d49dbdb824/wordmark-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/fc688624-8be2-4107-8ed6-b7d49dbdb824/wordmark-1200.webp",
  "original_filename": "wordmark-1200.webp",
  "size": 76000,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:18:54Z"
}
